/*
THIS IS THE COMPONENT THAT WILL BE USED TO RENDER THE THANK YOU PAGE
*/

import React, { useEffect, useState } from 'react';
import './ThankYouContainer.css';
import OrderService from '../../services/OrderService';
import { useSelector } from 'react-redux';
import { MONTHS } from '../../constants/DateConstants';
import { useTranslation } from 'react-i18next';
import ThankYouHeader from './ThankYouHeader';
import ThankYouStep from './ThankYouStep';
import ThankYouOrder from './ThankYouOrder';
import ThankYouSummary from './ThankYouSummary';
import ThankYouActions from './ThankYouActions';
import { Paper } from '@material-ui/core';

const orderID = 1971;

const ThankYouContainer = () => {
  const cart = useSelector(state => state.cartReducer);
  const [order, setOrder] = useState({});
  const [customer, setCustomer] = useState(null);

  const getOrder = async () => {
    const orders = await OrderService.getOrder(orderID);
    if (orders.status === 200) {
      setOrder(orders.json);
      setCustomer(orders.json.customer.first_name)
    }
  }

  useEffect(() => {
    getOrder();
  }, [])

  return (
    <div style={{ width: '100%' }}>
      {order && customer ?
        <div className="ThankYouContainer">
          <div className="TrackerLeft">
            <ThankYouHeader customer={customer} order={order.name} />
            <Paper>
              <ThankYouStep status={order.fulfillment_status} />
              <ThankYouOrder items={order.line_items} />
            </Paper>
          </div>
          <div className="TrackerRight">
            <ThankYouSummary order={order} cart={cart} />
            <ThankYouActions />
          </div>
        </div>
        : null
      }
    </div>

  )

}

export default ThankYouContainer;

